/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useMemo } from 'react'

import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { getProductListInfo } from '@mercadoni/sinister/dist/cjs/productv2'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'

import { isSearchIntersectional } from '../../utils/productDisplay'

const ProductDisplayLogic = ({
  Wrapper,
  products,
  category,
  trackSource,
  page,
  pages,
  onProductClick,
  fetchMoreData,
}: any) => {
  const { headerData, filtersPathInfo, pathNSearch } = useHeaderDataContext()
  const {
    // locale: clientLocale,
    enhanceImg = false,
    adsBanners,
  } = UseClientModelContext()
  // const { searchValue } = useQueryParams({
  //   useLocation,
  //   clientLocale,
  // });
  const searchValue = '' // TODO

  const listInfo = {
    screen_name: headerData?.screenName,
    filters: filtersPathInfo,
    keyword: filtersPathInfo?.searchTerm,
    path: pathNSearch?.pathname,
    ...getProductListInfo(trackSource, category?.name, category?.reference),
  }
  const params = {
    modalProductAction: onProductClick,
    simpleView: true,
    trackSource: 'search',
    listInfo,
  }

  const hasIntersectional = isSearchIntersectional({ params, adsBanners })
  const hasMoreData = useMemo(() => pages > page, [pages, page])

  return (
    <Wrapper
      products={products}
      hasMoreData={hasMoreData}
      trackSource={trackSource}
      enhanceImg={enhanceImg}
      onProductClick={onProductClick}
      fetchMoreData={fetchMoreData}
      listInfo={params.listInfo}
      adsBanners={adsBanners}
      hasIntersectional={hasIntersectional}
      searchValue={searchValue}
    />
  )
}

export default memo(ProductDisplayLogic)
